import $ from 'jquery';

const SELECTOR = {
    BURGER_MENU_NOTIFICATION: '.js-header-burger-notif',
}

const CLASS = {
    IS_ACTIVE: 'is-active'
}

export default class MobileNotifBurger {
    constructor() {
        var _self = this;
        _self.$notifBurger = $(SELECTOR.BURGER_MENU_NOTIFICATION);
        _self.isActive = false;

        window.EventBusCMS.addEventListener('toggleBurgerMobileNotif', event => {
            if ((event.detail.state === 'active') && (!_self.isActive)) {
                _self.activateBurgerMobileNotif();
            }

            if ((event.detail.state === 'unactive') && (_self.isActive)) {
                _self.deactivateNotifBurger();
            }
        });
    }

    /**
     * Activate Notif Burger
     */
    activateBurgerMobileNotif() {
        this.$notifBurger.addClass(CLASS.IS_ACTIVE);
        this.isActive = true;
    }


    /**
     * Deactivate Notif Burger
     */
    deactivateNotifBurger() {
        this.$notifBurger.removeClass(CLASS.IS_ACTIVE);
        this.isActive = false;
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/generic/notifBurger.js